import type { AmazonModuleConfig } from "@/ts/module";

export const amazonArticle: Pick<AmazonModuleConfig, "adSizesAmazon"> = {
	adSizesAmazon: {
		"div-gpt-ad-top-slot": [
			[970, 250],
			[728, 90],
			[320, 100],
			[320, 50],
			[300, 100],
			[300, 50],
		],
		"div-gpt-ad-rh-slot": [
			[300, 250],
			[300, 600],
			[120, 600],
		],
		"div-gpt-ad-rh-slot-2": [
			[300, 250],
			[300, 600],
			[120, 600],
		],
		"div-gpt-ad-rh-slot-3": [
			[300, 250],
			[300, 600],
			[120, 600],
		],
		"div-gpt-ad-rh-slot-4": [
			[300, 250],
			[300, 600],
			[120, 600],
		],
		"div-gpt-ad-rh-slot-5": [
			[300, 250],
			[300, 600],
			[120, 600],
		],
		"div-gpt-ad-rh-slot-last": [
			[300, 250],
			[300, 600],
			[120, 600],
		],
		"div-gpt-ad-mid-article-slot-other": [[300, 250]],
		"div-gpt-ad-mid-article-slot-1": [[300, 250]],
		"div-gpt-ad-mid-article-slot-2": [[300, 250]],
		"div-gpt-ad-mid-article-slot-perform": [[300, 250]],
		"div-gpt-ad-mid-article-slot-3": [[300, 250]],
		"div-gpt-ad-mid-article-slot-4": [[300, 250]],
		"div-gpt-ad-mid-article-slot-repeat": [[300, 250]],
		"div-gpt-ad-sticky-bottom-banner": [
			[320, 100],
			[320, 50],
			[300, 100],
			[300, 50],
		],
		"div-gpt-ad-skyscraper-left-slot": [
			[120, 600],
			[160, 600],
			[300, 250],
			[300, 600],
		],
		"div-gpt-ad-skyscraper-right-slot": [
			[120, 600],
			[160, 600],
			[300, 250],
			[300, 600],
		],
		"div-gpt-ad-iv-article-slot": [[300, 250]],
		"div-gpt-ad-iv-article-banner-slot": [
			[320, 50],
			[320, 100],
		],
		"div-gpt-ad-big-iv-article-slot": [
			[300, 250],
			[300, 600],
			[336, 280],
		],
		"div-gpt-ad-big-iv-article-mob-slot": [[300, 250]],
	},
};
